
// @ts-nocheck
// fragile: these checks must detect isNode correctly on the server and in the browser
// while staying compatible with react frameworks (create-react-app, react-starter-kit),
// the browserified cdn build, rspack/babel bundling, Electron and Angular.js

const isBrowser = typeof window !== 'undefined'

const isElectron = typeof process !== 'undefined' &&
                   typeof process.versions !== 'undefined' &&
                   typeof process.versions.electron !== 'undefined'

const isWebWorker = typeof WorkerGlobalScope !== 'undefined' && (self instanceof WorkerGlobalScope)

const isWindows = typeof process !== 'undefined' && process.platform === "win32"

const isDeno = typeof Deno !== 'undefined'

// bun is node-compatible (isNode stays true there), but its native fetch differs (e.g. built-in `proxy` option)
const isBun = typeof process !== 'undefined' &&
              typeof process.versions !== 'undefined' &&
              typeof process.versions.bun !== 'undefined'

const isNode = !(isBrowser || isWebWorker || isDeno)

// ----------------------------------------------------------------------------

export {
    isBrowser,
    isElectron,
    isWebWorker,
    isNode,
    isDeno,
    isBun,
    isWindows,
}
